import clsx from 'clsx';
import brightnessByColor from 'src/utils/colors';
import css from 'src/utils/css';

export const obterCorValida = (cor) =>
  typeof cor === 'string' && CSS.supports('color', cor) ? cor : '#fff';

export const obterClasseCor = (cor) =>
  css`
    .corQuadrante {
      background-color: ${cor};
    }
  `.corQuadrante;

const obterClasseAltura = (isWidget, heightBase) => {
  const altura = heightBase * 0.1;
  if (!isWidget || !Number.isFinite(altura) || altura <= 0) return 'tw:h-15';

  return css`
    .alturaLinha {
      height: ${altura}px;
    }
  `.alturaLinha;
};

export const BadgeMatrizRisco = ({ children, ...props }) => (
  <span
    className="tw:inline-flex tw:items-center tw:rounded-full tw:bg-muted tw:px-2 tw:py-1 tw:text-xs tw:font-bold tw:text-black"
    {...props}
  >
    {children}
  </span>
);

export const CodigosMatrizRisco = ({ children, ...props }) => (
  <span
    className="tw:line-clamp-4 tw:max-w-full tw:px-2 tw:text-left tw:text-[0.65rem] tw:leading-tight tw:wrap-break-word"
    {...props}
  >
    {children}
  </span>
);

export const CelulaMatrizRisco = ({
  cor,
  selecionada,
  desbotada,
  onClick,
  onMouseEnter,
  onMouseLeave,
  label,
  agrupada,
  emFoco,
  className,
  children,
}) => {
  const corFundo = obterCorValida(cor);
  return (
    <td
      className={clsx(
        'tw:relative tw:p-0',
        !agrupada && 'tw:border tw:border-border'
      )}
    >
      <button
        type="button"
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        aria-label={label}
        aria-pressed={Boolean(selecionada)}
        className={clsx(
          'tw:absolute tw:inset-0 tw:flex tw:w-full tw:cursor-pointer tw:flex-col tw:items-center tw:justify-center tw:gap-1 tw:border-0 tw:p-0 tw:focus-visible:z-10 tw:focus-visible:outline-2 tw:focus-visible:outline-ring tw:focus-visible:outline-offset-2',
          obterClasseCor(corFundo),
          brightnessByColor(corFundo) > 127.5
            ? 'tw:text-black'
            : 'tw:text-white',
          selecionada && !agrupada && 'tw:inset-ring tw:inset-ring-black',
          desbotada && 'tw:opacity-20',
          emFoco ? 'tw:brightness-90' : 'tw:hover:brightness-90',
          className
        )}
      >
        {children}
      </button>
    </td>
  );
};

const TabelaMatrizRiscoLayout = ({
  header,
  linhas,
  colunas,
  labelLinhas,
  labelColunas,
  renderCelula,
  isWidget,
  heightBase,
  positionMouse,
  positionInerente,
  inerente,
  setPositionMouse,
}) => {
  const classeAltura = obterClasseAltura(isWidget, heightBase);

  return (
    <div>
      {header && (
        <p className="tw:pt-3 tw:text-center tw:font-extrabold tw:text-muted-foreground tw:uppercase">
          {header}
        </p>
      )}
      <div className="tw:overflow-x-auto tw:pb-4">
        <table className="tw:w-full tw:table-fixed tw:border-collapse tw:border tw:border-border tw:text-sm">
          <thead>
            <tr>
              <th className="tw:border tw:border-border tw:p-3" />
              <th
                scope="colgroup"
                colSpan={colunas.length}
                className="tw:border tw:border-border tw:p-3 tw:text-center tw:uppercase"
              >
                {labelColunas}
              </th>
            </tr>
            <tr>
              <th className="tw:border tw:border-border tw:p-3 tw:text-center tw:align-middle tw:uppercase tw:[writing-mode:vertical-rl]">
                {labelLinhas}
              </th>
              {colunas.map((coluna, index) => (
                <th
                  key={coluna.id}
                  scope="col"
                  onMouseEnter={() => setPositionMouse?.(index, inerente)}
                  onMouseLeave={() => setPositionMouse?.(-1)}
                  className={clsx(
                    'tw:border tw:border-border tw:p-3 tw:text-center tw:align-middle tw:[writing-mode:vertical-rl]',
                    !!positionInerente === !!inerente &&
                      positionMouse === index &&
                      'tw:bg-black/7.5'
                  )}
                >
                  {coluna.nome}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {linhas.map((linha) => (
              <tr
                key={linha.id}
                className={clsx('tw:group/linha', classeAltura)}
              >
                <th
                  scope="row"
                  className="tw:border tw:border-border tw:py-0 tw:pr-0 tw:pl-3 tw:text-center tw:align-middle tw:font-bold tw:group-has-[button:hover]/linha:bg-black/7.5"
                >
                  {linha.nome}
                </th>
                {colunas.map((coluna, indexColuna) =>
                  renderCelula(linha, coluna, indexColuna)
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TabelaMatrizRiscoLayout;
